const accordion = {};

accordion.generic = () => {

    let itemOpen = "accordion__item-open";
    let $accordionTitles = document.querySelectorAll(".js-accordion-title");

    for (let i=0;i<$accordionTitles.length;i++) {
        $accordionTitles[i].addEventListener("click",toggleItem,false);
    }

    function toggleItem(e){
        let $itemOpen = document.querySelector("."+itemOpen);
        let sameElem = false;
        if ($itemOpen){
            closeItem($itemOpen);
            sameElem = $itemOpen.querySelector(".js-accordion-title") === e.target;
        }
        if (!sameElem){
            let panel = e.target.parentNode;
            openItem(panel);
        }
    }

    function closeItem($itemOpen){
        let panelCopy = $itemOpen.querySelector(".accordion__copy");
        $itemOpen.classList.remove(itemOpen);
        panelCopy.style.removeProperty("max-height");
    }

    function openItem(panel){
        let panelCopy = panel.querySelector(".accordion__copy");
        panel.classList.add(itemOpen);
        panelCopy.style.maxHeight = panelCopy.scrollHeight + "px";
    }

    // automatically open first accordion in page with specific class
    let defaultPanel = document.querySelector(".js-accordion-item-auto-open");
    if (defaultPanel){
        setTimeout(function() {
            openItem(defaultPanel);
        },1000);
    }

}

accordion.mobileOnly = () => {
    if (window.matchMedia('(max-width: 768px)').matches) {

        let itemMobileOpen = "accordion__item-mobile-open";
        let $accordionTitles = document.querySelectorAll(".js-accordion-mobile-title");

        for (let i=0;i<$accordionTitles.length;i++) {
            $accordionTitles[i].addEventListener("click",toggleMobileItem,false);
        }

        function toggleMobileItem(e){
            let $itemMobileOpen = document.querySelector("."+itemMobileOpen);
            let sameElem = false;
            if ($itemMobileOpen){
                closeMobileItem($itemMobileOpen);
                sameElem = $itemMobileOpen.querySelector(".js-accordion-mobile-title") === e.target;
            }
            if (!sameElem){
                let panel = e.target.parentNode;
                openMobileItem(panel);
            }
        }

        function closeMobileItem($itemMobileOpen){
            let panelCopy = $itemMobileOpen.querySelector(".accordion__copy");
            $itemMobileOpen.classList.remove(itemMobileOpen);
            panelCopy.style.removeProperty("max-height");
        }

        function openMobileItem(panel){
            let panelCopy = panel.querySelector(".accordion__copy");
            panel.classList.add(itemMobileOpen);
            panelCopy.style.maxHeight = panelCopy.scrollHeight + "px";
        }

        // automatically open first accordion in page with specific class
        let defaultPanel = document.querySelector(".js-accordion-item-mobile-auto-open");
        if (defaultPanel){
            setTimeout(function() {
                openMobileItem(defaultPanel);
            },1000);
        }

    }
}

accordion.init = () => {
    accordion.generic();
    accordion.mobileOnly();
}

export default accordion;
